import {
  API_ERROR,
  PREFIX_CODE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  PREFIX_CODE_LIST_SUCCESSFUL,
  PREFIX_CODE_ADD,
  PREFIX_CODE_ADD_SUCCESSFUL,
  PREFIX_CODE_ROW_DATA,
  PREFIX_CODE_ROW_DATA_SUCCESSFUL,
  PREFIX_CODE_DELETE,
  PREFIX_CODE_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  PerFixCodeList: [],
  model: false,
  error_msg: null,
  rowdata: {},
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
};

const PerFixCode = (state = initialState, action) => {
  switch (action.type) {
    case PREFIX_CODE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PREFIX_CODE_LIST_SUCCESSFUL:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        PerFixCodeList: action.payload.results,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case PREFIX_CODE_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case PREFIX_CODE_ADD_SUCCESSFUL:
      state = {
        ...state,
        // message: action.payload,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case PREFIX_CODE_ROW_DATA:
      state = {
        ...state,
        model: true,
        // rowdata: action.payload,
      };
      break;
    case PREFIX_CODE_ROW_DATA_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: action.payload.response,
      };
      break;
    case PREFIX_CODE_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case PREFIX_CODE_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PerFixCode;
